import { c as _c } from "react/compiler-runtime";
import './affinity-card-cta.scss';
import React from 'react';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { PolaroidImage } from '../../atoms/polaroid-image/polaroid-image.tsx';
import { AffinityCardGraphic, AffinityCardInteractive, AffinityCardSummary } from '../affinity-card/affinity-card.tsx';
export interface AffinityCardCtaProps {
  ctaLabel: string;
  href: string;
  imageSrc: string;
  summary: string;
  title: string;
}
export const AffinityCardCta: React.FC<AffinityCardCtaProps> = t0 => {
  const $ = _c(14);
  const {
    ctaLabel,
    href,
    imageSrc,
    summary,
    title
  } = t0;
  let t1;
  if ($[0] !== imageSrc || $[1] !== title) {
    t1 = <AffinityCardGraphic align="center"><PolaroidImage imgSrc={imageSrc} alt={title} /></AffinityCardGraphic>;
    $[0] = imageSrc;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== ctaLabel) {
    t2 = <ButtonStyle size="md" variant="primary" className="AffinityCard__cta mt-snug-lg w-full"><span>{ctaLabel}</span></ButtonStyle>;
    $[3] = ctaLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== summary || $[6] !== t2 || $[7] !== title) {
    t3 = <AffinityCardSummary title={title} summary={summary}>{t2}</AffinityCardSummary>;
    $[5] = summary;
    $[6] = t2;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== href || $[10] !== t1 || $[11] !== t3 || $[12] !== title) {
    t4 = <AffinityCardInteractive><Link href={href} aria-label={title} className="AffinityCard--cta trigger-hover--ButtonStyle">{t1}{t3}</Link></AffinityCardInteractive>;
    $[9] = href;
    $[10] = t1;
    $[11] = t3;
    $[12] = title;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};